// extracted by mini-css-extract-plugin
export default {"notificationLabel":"NotificationCard_notificationLabel__dJPoA","cardList":"NotificationCard_cardList__+mR+5"};